import { render, staticRenderFns } from "./MainReceipt.vue?vue&type=template&id=587d627d&scoped=true"
import script from "./MainReceipt.vue?vue&type=script&lang=ts"
export * from "./MainReceipt.vue?vue&type=script&lang=ts"
import style0 from "./MainReceipt.vue?vue&type=style&index=0&id=587d627d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../DATA/projects/nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587d627d",
  null
  
)

export default component.exports